export default __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets.webp";
export const Scaled = {
    "0.5x": __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets_0.5x.webp",
    "1x": __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets.webp",
    "2x": __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets.webp",
    "3x": __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets.webp",
    "4x": __webpack_public_path__ + "src/openspace/assets/png/home/concepts/smart_tickets.webp"
}